import React, { useCallback } from 'react'

import useTracker from 'src/lib/js/hooks/useTracker'
import { TrackingEvents } from 'shared/components/common/tracking/TrackingEvents'

import { t } from 'src/translations'

import { SubmitButton } from 'public/components/default_template/online_ordering/checkout/SubmitOrderButton'
import { useCart } from 'public/components/online_ordering/CartContext'
import { useFormContext } from 'react-hook-form'

const ContinuePaymentButton = ({
  enableIntlPayment
}: {
  enableIntlPayment: () => void
}) => {
  const { cartGuid } = useCart()
  const tracker = useTracker()
  const { trigger } = useFormContext()

  const buttonOnClick = useCallback(
    async (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()
      const valid = await trigger(undefined, { shouldFocus: true })
      tracker.track(TrackingEvents.INTERNATIONAL_CONTINUE_TO_PAYMENT_CLICKED, {
        cartGuid,
        canContinue: valid
      })
      if (valid) {
        enableIntlPayment()
      }
    },
    [cartGuid, tracker, enableIntlPayment, trigger]
  )

  return (
    <SubmitButton
      dataTestid='continueButtonPayment'
      label={t('continue-payment-button.continue-to-payment')}
      onClick={buttonOnClick}
    />
  )
}

export default ContinuePaymentButton
